import { Box, Stack, IconButton, useMediaQuery, useTheme } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useState } from "react";
import { Testimonial, TestimonialCard } from "./testimonial-card";

interface TestimonialCarouselProps {
  testimonials: Testimonial[];
}

export const TestimonialCarousel = ({ testimonials }: TestimonialCarouselProps) => {
  const [index, setIndex] = useState(0);
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const cardWidth = 648;
  const isMobile = !isMd;

  const handlePrev = () => setIndex((prev) => Math.max(prev - 1, 0));
  const handleNext = () => setIndex((prev) => Math.min(prev + 1, testimonials.length - 1));
  const canPrev = index > 0;
  const canNext = index < testimonials.length - 1;

  if (isMobile) {
    return (
      <Stack spacing={{xs:4,md:2}} justifyContent="center" alignItems="center" sx={{ mb: 4 }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: cardWidth,
            minWidth: 0,
            overflow: "hidden",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
              transform: `translateX(-${index * 100}%)`,
            }}
          >
            {testimonials.map((t, idx) => (
              <TestimonialCard key={idx} testimonial={t} />
            ))}
          </Box>
        </Box>
        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" sx={{ mt: 2}}>
          <IconButton onClick={handlePrev} disabled={!canPrev} aria-label="Previous testimonial" size="small" sx={{ borderRadius: "100%", color: '#111827', backgroundColor: '#ffffff', height: '44px', width: '44px' }}>
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
          <IconButton onClick={handleNext} disabled={!canNext} aria-label="Next testimonial" size="small" sx={{ borderRadius: "100%", color: '#111827', backgroundColor: '#ffffff', height: '44px', width: '44px' }}>
            <ArrowForwardIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" sx={{ mb: 4 }}>
      <IconButton onClick={handlePrev} disabled={!canPrev} aria-label="Previous testimonial" size="small" sx={{ borderRadius: "100%", color: '#111827', backgroundColor: '#ffffff', height: '44px', width: '44px' }}>
        <ArrowBackIcon sx={{ fontSize: '20px' }} />
      </IconButton>
      <Box
        sx={{
          width: `${cardWidth}px`,
          maxWidth: cardWidth,
          minWidth: 0,
          overflow: "hidden",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
            transform: `translateX(-${index * 100}%)`,
          }}
        >
          {testimonials.map((t, idx) => (
            <TestimonialCard key={idx} testimonial={t} />
          ))}
        </Box>
      </Box>
      <IconButton onClick={handleNext} disabled={!canNext} aria-label="Next testimonial" size="small" sx={{ borderRadius: "100%", color: '#111827', backgroundColor: '#ffffff', height: '44px', width: '44px' }}>
        <ArrowForwardIcon sx={{ fontSize: '20px' }} />
      </IconButton>
    </Stack>
  );
}; 